/** ISO 3166-1 alpha-2 → Türkçe ülke adı */

export const AUTOMOBILE_COUNTRY_NAMES: Record<string, string> = {
  TR: 'Türkiye',
  DE: 'Almanya',
  US: 'ABD',
  GB: 'Birleşik Krallık',
  FR: 'Fransa',
  IT: 'İtalya',
  ES: 'İspanya',
  PT: 'Portekiz',
  NL: 'Hollanda',
  BE: 'Belçika',
  LU: 'Lüksemburg',
  AT: 'Avusturya',
  CH: 'İsviçre',
  SE: 'İsveç',
  NO: 'Norveç',
  DK: 'Danimarka',
  FI: 'Finlandiya',
  PL: 'Polonya',
  CZ: 'Çekya',
  SK: 'Slovakya',
  HU: 'Macaristan',
  RO: 'Romanya',
  BG: 'Bulgaristan',
  GR: 'Yunanistan',
  HR: 'Hırvatistan',
  SI: 'Slovenya',
  RS: 'Sırbistan',
  UA: 'Ukrayna',
  RU: 'Rusya',
  JP: 'Japonya',
  KR: 'Güney Kore',
  CN: 'Çin',
  TW: 'Tayvan',
  HK: 'Hong Kong',
  IN: 'Hindistan',
  MY: 'Malezya',
  TH: 'Tayland',
  ID: 'Endonezya',
  VN: 'Vietnam',
  PH: 'Filipinler',
  SG: 'Singapur',
  AU: 'Avustralya',
  NZ: 'Yeni Zelanda',
  CA: 'Kanada',
  MX: 'Meksika',
  BR: 'Brezilya',
  AR: 'Arjantin',
  ZA: 'Güney Afrika',
  MA: 'Fas',
  EG: 'Mısır',
  AE: 'Birleşik Arap Emirlikleri',
  SA: 'Suudi Arabistan',
  IL: 'İsrail',
  IR: 'İran',
  GI: 'Cebelitarık',
  MC: 'Monako',
  SM: 'San Marino',
  VA: 'Vatikan',
};

let regionNamesTr: Intl.DisplayNames | null = null;

function intlCountryName(code: string): string | undefined {
  try {
    if (!regionNamesTr) {
      regionNamesTr = new Intl.DisplayNames(['tr'], { type: 'region' });
    }
    return regionNamesTr.of(code);
  } catch {
    return undefined;
  }
}

/** "TR" → "Türkiye", "MY" → "Malezya" */
export function formatAutomobileCountry(code?: string | null): string {
  if (!code) return '';
  const upper = code.trim().toUpperCase();
  if (!upper) return '';
  return AUTOMOBILE_COUNTRY_NAMES[upper] || intlCountryName(upper) || upper;
}

/** Admin seçim listesi (Türkçe ada göre sıralı) */
export const AUTOMOBILE_COUNTRY_OPTIONS: { code: string; label: string }[] = Object.entries(
  AUTOMOBILE_COUNTRY_NAMES
)
  .map(([code, label]) => ({ code, label }))
  .sort((a, b) => a.label.localeCompare(b.label, 'tr'));
